import actions from './actions'
import { EtcState } from './types'

const initialState: EtcState = {
  uiData: {},
}

interface UiData {
  [key: string]: unknown
}

interface EtcAction {
  type: string
  payload?: Partial<EtcState> | UiData
}

export default function etcReducer(state: EtcState = initialState, action: EtcAction): EtcState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...(action.payload as Partial<EtcState>) }
    case actions.SET_UI_DATA: {
      const newState = { ...state }
      newState.uiData = { ...newState.uiData, ...(action.payload as UiData) }
      return { ...newState }
    }
    default:
      return state
  }
}
